import Header from './components/Header';
import Hero from './components/Hero';
import ContactSection from './components/ContactSection';
import UpdatesSection from './components/UpdatesSection';
import CommentsSection from './components/CommentsSection';
import IndexSection from './components/IndexSection';
import FeaturesSection from './components/FeaturesSection';
import TopicsSection from './components/TopicsSection';
import MediaSection from './components/MediaSection';
import CarouselSection from './components/CarouselSection';
import AboutSection from './components/AboutSection';
import AppSection from './components/AppSection';
import RankingSection from './components/RankingSection';
import CardsSection from './components/CardsSection';
import FAQSection from './components/FAQSection';
import Footer from './components/Footer';

export default function Home() {
  return (
    <div className="min-h-screen bg-background-50">
      <Header />
      <main>
        <Hero />
        <ContactSection />
        <UpdatesSection />
        <CommentsSection />
        <IndexSection />
        <FeaturesSection />
        <TopicsSection />
        <MediaSection />
        <CarouselSection />
        <AboutSection />
        <AppSection />
        <RankingSection />
        <CardsSection />
        <FAQSection />
      </main>
      <Footer />
    </div>
  );
}